import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/page/login'
import Register from '@/components/page/register'
import ForgetThePassword from '@/components/page/forgetThePassword'
import Home from '@/components/page/home'
import OrderManagment from '@/components/page/orderManagment'
import OrderDetails from '@/components/page/orderDetails'
import Commodity from '@/components/page/commodity'
import Information from '@/components/page/information'
import Customer from '@/components/page/customer'
import Bill from '@/components/page/bill'
import Set from '@/components/page/set'
import AccountSettings from '@/components/page/accountSettings'
import ChangePassword from '@/components/page/changePassword'
import CreatStore from '@/components/page/creatStore'
import ModifyStore from '@/components/page/ModifyStore'
import charge from '@/components/page/charge'
import invoicing from '@/components/page/invoicing'
import invoicingSet from '@/components/page/invoicingSet'
import invoicingFather from '@/components/page/invoicingFather'
import editSupplier from '@/components/page/editSupplier'
import stockInquiry from '@/components/page/stockInquiry'
import singleStockInquiry from '@/components/page/singleStockInquiry'
import stockFlowList from '@/components/page/stockFlowList'
import stockFlowDetail from '@/components/page/stockFlowDetail'
import stockFlowReturnDetail from '@/components/page/stockFlowReturnDetail'
import stockFlowInventoryDetail from '@/components/page/stockFlowInventoryDetail'
import stockFlowTransferDetail from '@/components/page/stockFlowTransferDetail'
import stockCheck from '@/components/page/stockCheck'
import InventoryGoods from '@/components/page/InventoryGoods'
import InventoryDetail from '@/components/page/InventoryDetail'
import goodsChange from '@/components/page/goodsChange'
import goodsChangeAdd from '@/components/page/goodsChangeAdd'
import goodsChangeDetail from '@/components/page/goodsChangeDetail'
import putGoodsInStock from '@/components/page/putGoodsInStock'
import addClassify from '@/components/page/addClassify'
import addUnitManagement from '@/components/page/addUnitManagement'
import goodsPurchase from '@/components/page/goodsPurchase'
import addGoodsPurchase from '@/components/page/addGoodsPurchase'
import goodsPurchaseReturn from '@/components/page/goodsPurchaseReturn'
import addGoodsPurchaseReturn from '@/components/page/addGoodsPurchaseReturn'
import goodsPurchaseReturnDetail from '@/components/page/goodsPurchaseReturnDetail'
import goodsPurchaseDetail from '@/components/page/goodsPurchaseDetail'
import chooseGoodsPurchasePrice from '@/components/page/chooseGoodsPurchasePrice'
import chooseGoods from '@/components/page/chooseGoods'
import chooseAddGoods from '@/components/page/chooseAddGoods'
import chooseReturnGoods from '@/components/page/chooseReturnGoods'
import choosePurcharseGoods from '@/components/page/choosePurcharseGoods'
import choosePurcharseReturn from '@/components/page/choosePurcharseReturn'
import invoicingGoodsList from '@/components/page/invoicingGoodsList'
import unitManagement from '@/components/page/unitManagement'
import cashierOrder from '@/components/page/cashierOrder'
import ZWHXJL from '@/components/page/ZWHXJL'
import shiftChange from '@/components/page/shiftChange'
import cashierOrderHome from '@/components/page/cashierOrderHome'
import cashierGoodsDetails from '@/components/page/cashierGoodsDetails'
import cashierOrderNoBarcode from '@/components/page/cashierOrderNoBarcode'
import cashierOrderAllDiscount from '@/components/page/cashierOrderAllDiscount'
import cashierOrderMoreFunction from '@/components/page/cashierOrderMoreFunction'
import cashierOrderAD from '@/components/page/cashierOrderAD'
import cashierOrderVip from '@/components/page/cashierOrderVip'
import cashierOrderVipIfm from '@/components/page/cashierOrderVipIfm'
import cashierOrderVipRecharge from '@/components/page/cashierOrderVipRecharge'
import cashierOrderAddVip from '@/components/page/cashierOrderAddVip'
import cashierOrderPay from '@/components/page/cashierOrderPay'
import returnsAndRefunds from '@/components/page/returnsAndRefunds'
import returnsAndRefundsOrders from '@/components/page/returnsAndRefundsOrders'
import cashierOrderPayResult from '@/components/page/cashierOrderPayResult'
import orderRefund from '@/components/page/orderRefund'
import returnOfTheTreasury from '@/components/page/returnOfTheTreasury'
import cashierGoodsMonads from '@/components/page/cashierGoodsMonads'

import integralManage from '@/components/page/integralManage'
import addintegralGoods from '@/components/page/addintegralGoods'
import couponList from '@/components/page/couponList'
import cardCouponList from '@/components/page/cardCouponList'
import intergralOrder from '@/components/page/intergralOrder'
import consumeRecord from '@/components/page/consumeRecord'
import intergralRecord from '@/components/page/intergralRecord'

import gasManage from '@/components/page/gasManage'
import gasOrder from '@/components/page/gasOrder'
import gasAddInt from '@/components/page/gasAddInt'
import gasAddMark from '@/components/page/gasAddMark'
import gasSite from '@/components/page/gasSite'

Vue.use(Router)
var notFound = {
    template: '<h2>404 该页面不存在</h2>'
}
export default new Router({
    routes: [{
        path: '/',
        name: 'login',
        component: login,
        meta: {
            keepAlive: false,
        }
    },
    //页面不存在的跳转页面
    {
        path: '*',
        component: notFound
    },
    {
      path: '/invoicingFather',
      component: invoicingFather,
      children: [
        {
          path: 'invoicing',
          name:'进销存管理',
          component: invoicing,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'invoicingSet',
          name:'供应商管理',
          component: invoicingSet,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsPurchase',
          name:'进货单管理',
          component: goodsPurchase,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'addGoodsPurchase',
          name:'进货单管理',
          component: addGoodsPurchase,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsPurchaseReturn',
          name:'进货退货单',
          component: goodsPurchaseReturn,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'addGoodsPurchaseReturn',
          name:'进货退货单管理',
          component: addGoodsPurchaseReturn,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsPurchaseReturnDetail',
          name:'进货退货单管理',
          component: goodsPurchaseReturnDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsPurchaseDetail',
          name:'进货单管理',
          component: goodsPurchaseDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'chooseGoodsPurchasePrice',
          name:'选择进货单',
          component: chooseGoodsPurchasePrice,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'chooseGoods',
          name:'选择商品',
          component: chooseGoods,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'chooseAddGoods',
          name:'选择商品',
          component: chooseAddGoods,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'chooseReturnGoods',
          name:'选择商品',
          component: chooseReturnGoods,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'choosePurcharseGoods',
          name:'选择进货单',
          component: choosePurcharseGoods,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'choosePurcharseReturn',
          name:'选择进货单',
          component: choosePurcharseReturn,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'invoicingGoodsList',
          name:'进货单管理',
          component: invoicingGoodsList,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'addClassify',
          name:'添加分类',
          component: addClassify,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'addUnitManagement',
          name:'添加单位',
          component: addUnitManagement,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'editSupplier',
          name:'供应商管理',
          component: editSupplier,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockInquiry',
          name:'库存查询',
          component: stockInquiry,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'singleStockInquiry',
          name:'库存查询',
          component: singleStockInquiry,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockFlowList',
          name:'商品库存',
          component: stockFlowList,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockFlowReturnDetail',
          name:'商品库存',
          component: stockFlowReturnDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockFlowDetail',
          name:'商品库存',
          component: stockFlowDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockFlowInventoryDetail',
          name:'商品库存',
          component: stockFlowInventoryDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockFlowTransferDetail',
          name:'商品库存',
          component: stockFlowTransferDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'stockCheck',
          name:'库存盘点',
          component: stockCheck,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'InventoryGoods',
          name:'库存盘点',
          component: InventoryGoods,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'InventoryDetail',
          name:'库存盘点',
          component: InventoryDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsChange',
          name:'调拨单',
          component: goodsChange,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsChangeAdd',
          name:'选择商品',
          component: goodsChangeAdd,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'goodsChangeDetail',
          name:'调拨单',
          component: goodsChangeDetail,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
        {
          path: 'putGoodsInStock',
          name:'入库',
          component: putGoodsInStock,
          meta: {
            keepAlive: true,
            titleShow:true,
            requireAuth: true
          },
        },
      ],
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/cashierOrder',
      name: '收银开单',
      component: cashierOrder,
      meta: {
        keepAlive: false,
      },
      children: [
        {
          path: 'goodsMonads',
          component: cashierGoodsMonads,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'goodsDetails',
          component: cashierGoodsDetails,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderHome',
          component: cashierOrderHome,
          meta: {
            requireAuth: true
          }
        
        },
        {
          path: 'cashierOrderNoBarcode',
          component: cashierOrderNoBarcode,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderAllDiscount',
          component: cashierOrderAllDiscount,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderMoreFunction',
          component: cashierOrderMoreFunction,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderVip',
          component: cashierOrderVip,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderVip/vipInformation',
          component: cashierOrderVipIfm,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderVip/vipRecharge',
          component: cashierOrderVipRecharge,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderVip/addVip',
          component: cashierOrderAddVip,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderPay',
          component: cashierOrderPay,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
        {
          path: 'cashierOrderPay/result',
          component: cashierOrderPayResult,
          meta: {
            showWhiteShadow: true,
            requireAuth: true
          },
        },
      ]
    },
    {
      path: '/returnOfTheTreasury',
      name: '退货入库',
      component: returnOfTheTreasury,
      meta: {
        keepAlive: true,
        requireAuth: true
      },
    },
    {
      path: '/orderRefund',
      name: '订单退款',
      component: orderRefund,
      meta: {
        keepAlive: true,
        requireAuth: true
      },
    },
    {
      path: '/cashierOrderAD',
      name: '收银开单广告页',
      component: cashierOrderAD,
      meta: {
        keepAlive: true,
        requireAuth: true
      },
    },
    {
        path: '/returnsAndRefunds',
        name: 'returnsAndRefunds',
        component: returnsAndRefunds,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/shiftChange',
        name: 'shiftChange',
        component: shiftChange,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
      path: '/returnsAndRefundsOrders',
      name: 'returnsAndRefundsOrders',
      component: returnsAndRefundsOrders,
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },
    {
      path: '/ZWHXJL',
      name: 'ZWHXJL',
      component: ZWHXJL,
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },


    {
        path: '/unitManagement',
        name: 'unitManagement',
        component: unitManagement,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
            keepAlive: false,
            requireAuth: true
        }
    },
    {
        path: '/creatStore',
        name: 'CreatStore',
        component: CreatStore,
        meta: {
            keepAlive: false,
            requireAuth: true
        }
    },
    {
        path: '/forgetThePassword',
        name: 'ForgetThePassword',
        component: ForgetThePassword,
        meta: {
            keepAlive: false,
            requireAuth: true
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/charge',
        name: 'charge',
        component: charge,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
      path: '/orderManagment',
      name: 'OrderManagment',
      component: OrderManagment,
      meta: {
        keepAlive: true,
        requireAuth: true
      },
    },
    {
        path: '/orderDetails',
        name: 'OrderDetails',
        component: OrderDetails,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/commodity',
        name: 'Commodity',
        component: Commodity,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/information',
        name: 'Information',
        component: Information,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/customer',
        name: 'Customer',
        component: Customer,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/bill',
        name: 'Bill',
        component: Bill,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/set',
        name: 'Set',
        component: Set,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },
    {
        path: '/accountSettings',
        name: 'AccountSettings',
        component: AccountSettings,
        meta: {
            keepAlive: false,
            requireAuth: true
        }
    },
    {
        path: '/changePassword',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
            keepAlive: false,
            requireAuth: true
        }
    },
    {
        path: '/modifyStore',
        name: 'ModifyStore',
        component: ModifyStore,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    }, {
        path: '/gasManage',
        name: 'gasManage',
        component: gasManage,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    }, {
        path: '/gasOrder',
        name: 'gasOrder',
        component: gasOrder,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    }, {
        path: '/gasAddInt',
        name: 'gasAddInt',
        component: gasAddInt,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    }, {
        path: '/gasAddMark',
        name: 'gasAddMark',
        component: gasAddMark,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    }, {
        path: '/gasSite',
        name: 'gasSite',
        component: gasSite,
        meta: {
            keepAlive: true,
            requireAuth: true
        }
    },{
      path: '/integralManage',
      name: 'integralManage',
      component: integralManage,
      meta: {
          keepAlive: true,
          requireAuth: true
      }
    },{
      path: '/addintegralGoods',
      name:'积分商品',
      component: addintegralGoods,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },{
      path: '/couponList',
      name:'优惠券管理',
      component: couponList,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },{
      path: '/cardCouponList',
      name:'优惠券管理',
      component: cardCouponList,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },{
      path: '/intergralOrder',
      name:'积分订单',
      component: intergralOrder,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },{
      path: '/consumeRecord',
      name:'会员消费记录',
      component: consumeRecord,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },
    {
      path: '/intergralRecord',
      name:'积分记录',
      component: intergralRecord,
      meta: {
        keepAlive: true,
        titleShow:true,
        requireAuth: true
      },
    },
  ]
})

// VueRouter.beforeEach((from, to, next) => {
//   let userId = localStorage.getItem('userId')
//   if (to.meta.requireAuth) { // 判断跳转的路由是否需要登录
//       if (userId) { 
//           next() // 已登录
//       } else {
//           next({
//               path: '/',
//               query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
//           })
//       }
//   } else {
//      next()
//   }
// })


// WEBPACK FOOTER //
// ./src/router/index.js